import { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { AuthContext } from "../../../../contexts/AuthContext";
import { adminService } from "../../../../services/api/adminService";
import EmployeeDetail from "../../components/EmployeeDetail/EmployeeDetail";

const UserInfo = ({ mode = "view" }) => {
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  const { id } = useParams();
  const handleBack = () => navigate("/danh-sach-tai-khoan");

  const onCancel = () => {
    if (mode === "edit" || mode === "create") {
      if (id) {
        navigate(`/danh-sach-tai-khoan/tai-khoan/${id}`);
      } else {
        handleBack();
      }
    } else {
      handleBack();
    }
  };

  const onSuccess = async (payload) => {
    try {
      if (mode === "create") {
        await adminService.create_user(payload, token);
        toast.success("Tạo tài khoản thành công!");
        handleBack();
      } else {
        await adminService.update_user(payload, id, token);
        toast.success("Cập nhật tài khoản thành công!");
        navigate(`/danh-sach-tai-khoan/tai-khoan/${id}`);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Thao tác thất bại.");
      throw error;
    }
  };

  return (
    <div className="h-full overflow-auto bg-gray-50">
      <div className="mx-auto">
        <EmployeeDetail
          employeeId={id}
          mode={mode}
          layout="page"
          onSuccess={onSuccess}
          onCancel={onCancel}
          onBack={handleBack}
          onEditClick={() => navigate(`/danh-sach-tai-khoan/tai-khoan/${id}/chinh-sua`)}
        />
      </div>
    </div>
  );
};

export default UserInfo;